export const getButtonFocusOverrideStyle = outlineColor => ({
  outline: `1px solid ${outlineColor}`,
  outlineOffset: -1,
  '&:after': {
    border: 0,
  },
});
